import React from "react";
import Form from "rsuite/es/Form";
import { Schema } from "rsuite";
import styled from "styled-components";

import FormHOC from "hoc/FilltersForm";
import Text from "components/Form/Text";

const { StringType } = Schema.Types;

const filtersModel = Schema.Model({
    str: StringType().maxLength(256, "The maximum is only 256 characters."),
});


const AccessListExceptionFilter = ({ onChange, defaultFilters }) => {
    return (
        <>
            <Form
                className="access_list_exception_filter"
                model={filtersModel}
                layout="inline"
                onChange={onChange}
                formDefaultValue={defaultFilters}
            >
                <StyledTextField
                    name="str"
                    placeholder="Origin/Origin prefix/Destination/Sender ID"
                />
            </Form>
        </>
    );
};

export default FormHOC(AccessListExceptionFilter, filtersModel, 800);

const StyledTextField = styled(Text)`
    &&& {
        width: 100%;
        min-width: 300px;
    }
`;
